// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

// 全局语数配置
import configTitle from './config'
Vue.prototype.$t = configTitle
    // 
    // import sensors from '../static/js/sensorsdata.es6.min.js'
    // sensors.init({
    //   server_url: 'https://datasink.lshmnc.com.cn/sa?project=default',
    //   is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    //   use_client_time:true, 
    //   send_type:'beacon',
    //   heatmap: {
    //      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    //      clickmap:'default',
    //      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    //      scroll_notice_map:'not_collect'
    //   }
    // });
    // sensors.quick('autoTrack'); //用于采集 $pageview 事件。
    /**
     * videoplayer 组件
     */
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
/**
 * vant 组件
 */
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(Vant);
import { Notify } from 'vant';
Vue.use(Notify);


/**
 * axios
 */
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios;

/**
 * videoplayer
 */
Vue.use(VideoPlayer)

/**
 * element-ui
 */
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})


/**
 * 自适应rem
 */
// 设定body文字尺寸
const setHtmlFontSize = () => {
    // 640 默认设计稿大小; 640px = 6.4rem ;每个元素px基础上/100
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    // 得到html的Dom元素
    const htmlDom = document.getElementsByTagName('html')[0];
    if (htmlWidth <= 750) {
        // 设置根元素字体大小
        htmlDom.style.fontSize = htmlWidth / 7.5 + 'px';
    } else {
        htmlDom.style.fontSize = '100px';
    }

};
window.onresize = setHtmlFontSize;
setHtmlFontSize();

/**
 * 自定义标题（待开发）
 */
// router.js
const defaultTitle = 'oasystem'
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : defaultTitle
    next()
})


// WEBPACK FOOTER //
// ./src/main.js